import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoIosArrowForward } from "react-icons/io";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { handleLoading } from "../../store/actions/loadingAction";
import HeaderContainer from "../../components/UI/‌Header/HeaderContainer";
import { t } from "i18next";
import { bioGetCredential, onDeleteUser } from "../../db/BioStar/APIs";
import separateFaceIdType from "../../utils/separateFaceIdType";
import { bioCreateUser } from "../../db/BioStar/APIs";
import { createCredential } from "../../store/actions/credentialsAction";
const smalltalk = require("smalltalk");

export function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function GetUserCredentialsScreen() {
  const history = useHistory();
  const Users = useSelector((state) => state.users.users);
  const [tryAgain, setTryAgain] = useState(false);
  const location = useLocation();
  const isUpdatePath = location.pathname.includes("update");
  const centerId = JSON.parse(localStorage.getItem("centerId")).centerId;
  const accessGroups = useSelector((state) => state.accessGroups.accessGroups);
  const query = useQuery()
  const faceIp = query.get('faceIp')
  const currentUser = useSelector((state) => state.users.currentUser);
  
  const faceType = separateFaceIdType(centerId);

  useEffect(() => {
    // if (!currentUser?._id || isUpdatePath) getUserCredential();
    setup();
  }, []);

  const setup = async () => {
    try {
      handleLoading();
      
      const res = await getUserCredential(currentUser,isUpdatePath);
      handleLoading();
      history.replace("/users");
    } catch (e) {
      console.log(e);
      alert(JSON.stringify(e));
    }
  };

  const getUserCredential = async (newUser,isUpdatePath) => {
    try {
      const newCredential = await bioGetCredential(newUser, accessGroups,faceIp,isUpdatePath)
        .catch((e) => {
          if (e == -1) {
            setTryAgain(true);
          }
          smalltalk.alert("", t("somethingWentWrong"));
        })
        .then((a) => {
          console.log(a);
        });

      } catch (e) {
      smalltalk.alert("", t("somethingWentWrong"));
      throw e;
    }
  };

  const onBack = async () => {
    // if (currentUser?._id) {
    //   history.goBack();
    //   return;
    // }
    // handleLoading();
    // await onDeleteUser(currentUser.bioStarID);
    // history.replace("/users");
    // handleLoading();
  };

  return (
    <div className="flex flex-col items-center w-full ">
      <HeaderContainer
        onBackCheck={currentUser?._id ? false : true}
        onBackFunction={onBack}
        label={t("createUser")}
      />
      {/* {currentUser && (
        <Container
          getUserCredential={getUserCredential}
          onSubmit={onSubmit}
          tryAgain={tryAgain}
          currentUser={currentUser}
        />
      )} */}
    </div>
  );
}

const Container = ({ onSubmit, currentUser, tryAgain, getUserCredential }) => {
  return (
    <div className="w-4/5 mt-8 border">
      <InputContainer currentUser={currentUser} />
      {
        <SubmitButton
          getUserCredential={getUserCredential}
          onSubmit={onSubmit}
          tryAgain={tryAgain}
          currentUser={currentUser}
        />
      }
    </div>
  );
};

const InputContainer = ({ currentUser }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{ backgroundColor: "#F7F7F7" }}
      className="items-center justify-center py-24"
    >
      <div className="flex flex-col items-center justify-center w-full ">
        {!currentUser?._id ? (
          <img
            src="https://cdn.dribbble.com/users/93860/screenshots/3985406/face-id_1.gif"
            className="h-60 w-80"
          />
        ) : (
          <img
            src="https://cliply.co/wp-content/uploads/2021/03/372103860_CHECK_MARK_400px.gif"
            className="h-40 w-60"
          />
        )}
        {!currentUser?._id && (
          <h1 className="text-2xl opacity-50">{t("addFaceLabel")}</h1>
        )}
      </div>
    </div>
  );
};

const SubmitButton = ({
  onSubmit,
  tryAgain,
  getUserCredential,
  currentUser,
}) => {
  const { t } = useTranslation();

  return (
    <button
      // disabled={!tryAgain || currentUser?._id}
      className="flex flex-row items-center justify-end w-full p-3 cursor-pointer bg-mainAqwaBlue hover:opacity-80"
      onClick={tryAgain ? getUserCredential : onSubmit}
    >
      <h1 className="mr-1 font-bold text-white">
        {tryAgain ? t("tryAgain") : t("submit")}
      </h1>
      <IoIosArrowForward color="#fff" />
    </button>
  );
};

export default GetUserCredentialsScreen;
